import { fetchRentalPrice } from "../../helper/perhitunganHarga.js";
import { refreshJadwalBulanAktif, resetModalJadwal } from "../penjadwalan/dataMobil.js";
import {
    getCoordinates,
    getDistanceFromInputs,
    handleDistanceError,
    initAutocompleteKota,
    initAutocompleteKotaAlamat,
    tampilkanPetaSingleTrip,
    getDistanceFromCoords,
} from "../../helper/setupAutocompleteCity.js";

window.PPN_RATE = 0.11;

window.calculatePPN = function (subtotal) {
    const ppnFilter = document.getElementById("ppnFilter");

    if (!ppnFilter?.checked) {
        return {
            ppn: 0,
            grandTotal: subtotal,
        };
    }

    const ppn = subtotal * window.PPN_RATE;

    return {
        ppn,
        grandTotal: subtotal + ppn,
    };
};

window.renderPPNInfo = function (elementId, ppn) {
    const el = document.getElementById(elementId);

    if (!el) return;

    if (ppn > 0) {
        el.classList.remove("hidden");
        el.innerHTML =
            `Include PPN 11% = Rp ${new Intl.NumberFormat("id-ID").format(ppn)}`;
    } else {
        el.classList.add("hidden");
        el.innerHTML = "";
    }
};

export let selectedCarTypeId = null;
window.tarifTol = 0;
export function setSelectedCarTypeId(id) {selectedCarTypeId = id};
let distanceKm = 0;
const chkDalamKotaPenjadwalan = document.getElementById("chkDalamKotaPenjadwalan");
const lblDalamKotaPenjadwalan = document.getElementById("lblDalamKotaPenjadwalan");
const kotaTujuanPenjadwalan = document.getElementById("kotaTujuanPenjadwalan");

export function resetPenjadwalan() {
    const inputKota = document.getElementById("kotaPenjemputanPenjadwalan");
    if (inputKota) inputKota.value = "";
}

export function showModalPenjadwalan(
    modalId,
    id,
    lastCount,
    tanggalStr,
    firstData,
    selectedMobil,
    dynamicMobil,
    companyCity,
    lat,
    lng,
    companyIdMain,
    paramSimpan,
) {
    if (dynamicMobil?.id) {
        setSelectedCarTypeId(dynamicMobil?.id);
    }
    loadPaymentMethods();
    const modal = document.getElementById(modalId);
    if (!modal || !firstData) return;
    const content = modal.querySelector("#modalContentJadwal");
    const idType = modal.querySelector("#car_type_id");
    const tujuanPenjadwalan = modal.querySelector("#tujuanPenjadwalan");
    const tanggalSampai = document.getElementById("tanggal_sampai");
    const tanggalSampaiLepas = document.getElementById("tanggal_sampai_lepas");
    const scheduleId = id || null;
    const jadwalType = document.getElementById("jadwalSelectedType").value;

    // sembunyikan semua
    document.getElementById("contentPlus").classList.add("hidden");
    document.getElementById("contentBulanan").classList.add("hidden");
    document.getElementById("contentLepas").classList.add("hidden");

    // tampilkan sesuai type
    let dateText, typeEl, transmissionEl, yearEl, imageEl, kotaTujuanEl;
    if (jadwalType === "plus") {
        document.getElementById("contentBulanan").classList.add("hidden");
        document.getElementById("contentPlus").classList.remove("hidden");
        document.getElementById("contentLepas").classList.add("hidden");

        dateText = modal.querySelector("#modalDateJadwal");
        typeEl = modal.querySelector("#modalTypeJadwal");
        transmissionEl = modal.querySelector("#modalTransmissionJadwal");
        yearEl = modal.querySelector("#modalYearJadwal");
        imageEl = modal.querySelector("#modalImageJadwal");
    } else if (jadwalType === "bulanan") {
        document.getElementById("contentPlus").classList.add("hidden");
        document.getElementById("contentBulanan").classList.remove("hidden");
        document.getElementById("contentLepas").classList.add("hidden");

        dateText = modal.querySelector("#modalDateJadwalBulanan");
        typeEl = modal.querySelector("#modalTypeJadwalBulanan");
        transmissionEl = modal.querySelector("#modalTransmissionJadwalBulanan");
        yearEl = modal.querySelector("#modalYearJadwalBulanan");
        imageEl = modal.querySelector("#modalImageJadwalBulanan");
        kotaTujuanEl = document.getElementById("kotaTujuanPenjadwalanBulanan");

        kotaTujuanEl.addEventListener("blur", async function () {
            if (!dynamicMobil || !dynamicMobil.id) {
                return;
            }

            try {
                const dataHarga = await cariHargaMobil(
                    dynamicMobil.id,
                    companyIdMain,
                    paramSimpan,
                );
                if (dataHarga.length > 0) {
                    const hargaBulanan = parseFloat(
                        dataHarga[0].harga_bulanan || 0,
                    );
                    const lamaSewaEl = document.getElementById(
                        "lamaSewaJadwalBulanan",
                    );
                    const marginJadwalEl = document.getElementById(
                        "marginJadwalBulanan",
                    );
                    const hargaEl = document.getElementById(
                        "harga_jadwal_bulanan",
                    );

                    const lamaSewa = parseInt(lamaSewaEl?.value || 0);
                    const marginJadwal = parseFloat(marginJadwalEl?.value || 0);

                    // 🔹 Hitung total harga + margin
                    let totalHarga = (hargaBulanan * lamaSewa) + (marginJadwal * lamaSewa);

                    const ppnResult = window.calculatePPN(totalHarga);

                    document.getElementById(
                        "harga_jadwal_bulanan"
                    ).value = new Intl.NumberFormat("id-ID")
                        .format(totalHarga);

                    document.getElementById(
                        "ppn_jadwal_bulanan"
                    ).value = new Intl.NumberFormat("id-ID")
                        .format(ppnResult.ppn);

                    document.getElementById(
                        "grand_total_jadwal_bulanan"
                    ).value = new Intl.NumberFormat("id-ID")
                        .format(ppnResult.grandTotal);

                    if (hargaEl) {
                        // Format angka tanpa "Rp"
                        const formatted = totalHarga.toLocaleString("id-ID");

                        if (
                            hargaEl.tagName === "INPUT" ||
                            hargaEl.tagName === "TEXTAREA"
                        ) {
                            hargaEl.value = formatted;
                        } else {
                            hargaEl.textContent = formatted;
                        }
                    } else {
                        console.warn(
                            "⚠️ Elemen #harga_jadwal_bulanan tidak ditemukan",
                        );
                    }
                } else {
                    console.warn("⚠️ Data harga mobil kosong");
                }
            } catch (error) {
                console.error("🔥 Gagal mengambil harga mobil:", error);
            }
        });

        const marginJadwalEl = document.getElementById("marginJadwalBulanan");
        marginJadwalEl.addEventListener("change", async function () {
            if (!dynamicMobil || !dynamicMobil.id) {
                return;
            }

            try {
                const dataHarga = await cariHargaMobil(
                    dynamicMobil.id,
                    companyIdMain,
                    paramSimpan,
                );
                if (dataHarga.length > 0) {
                    const hargaBulanan = parseFloat(
                        dataHarga[0].harga_bulanan || 0,
                    );
                    const lamaSewaEl = document.getElementById(
                        "lamaSewaJadwalBulanan",
                    );
                    const hargaEl = document.getElementById(
                        "harga_jadwal_bulanan",
                    );
                    const lamaSewa = parseInt(lamaSewaEl?.value || 0);
                    const marginJadwal = parseFloat(marginJadwalEl?.value || 0);
                    let totalHarga = (hargaBulanan * lamaSewa) + (marginJadwal * lamaSewa);

                    const ppnResult = window.calculatePPN(totalHarga);

                    document.getElementById(
                        "harga_jadwal_bulanan"
                    ).value = new Intl.NumberFormat("id-ID")
                        .format(totalHarga);

                    document.getElementById(
                        "ppn_jadwal_bulanan"
                    ).value = new Intl.NumberFormat("id-ID")
                        .format(ppnResult.ppn);

                    document.getElementById(
                        "grand_total_jadwal_bulanan"
                    ).value = new Intl.NumberFormat("id-ID")
                        .format(ppnResult.grandTotal);

                    if (hargaEl) {
                        const formatted = totalHarga.toLocaleString("id-ID");

                        if (
                            hargaEl.tagName === "INPUT" ||
                            hargaEl.tagName === "TEXTAREA"
                        ) {
                            hargaEl.value = formatted;
                        } else {
                            hargaEl.textContent = formatted;
                        }
                    } else {
                        console.warn(
                            "⚠️ Elemen #harga_jadwal_bulanan tidak ditemukan",
                        );
                    }
                } else {
                    console.warn("⚠️ Data harga mobil kosong");
                }
            } catch (error) {
                console.error("🔥 Gagal mengambil harga mobil:", error);
            }
        });

        // Event klik tombol tambah jadwal bulanan
        document
            .getElementById("btnPlusJadwalBulan")
            .addEventListener("click", async function () {
                if (!dynamicMobil.id) {
                    return;
                }

                const lamaSewaEl = document.getElementById(
                    "lamaSewaJadwalBulanan",
                );
                const hargaEl = document.getElementById("harga_jadwal_bulanan");
                const marginJadwalEl = document.getElementById(
                    "marginJadwalBulanan",
                );

                if (!lamaSewaEl || !hargaEl) {
                    return;
                }
                try {
                    // Tambah lama sewa
                    let lamaSewa = parseInt(lamaSewaEl.value || "0");
                    lamaSewa++;
                    lamaSewaEl.value = lamaSewa;

                    // Ambil harga mobil dari API
                    const dataHarga = await cariHargaMobil(
                        dynamicMobil.id,
                        companyIdMain,
                        paramSimpan,
                    );

                    if (dataHarga.length > 0) {
                        const hargaBulanan = parseFloat(
                            dataHarga[0].harga_bulanan || 0,
                        );
                        const marginJadwal = parseFloat(
                            marginJadwalEl?.value || 0,
                        );
                        let totalHarga =
                            (hargaBulanan * lamaSewa) + (marginJadwal * lamaSewa);

                        const ppnResult = window.calculatePPN(totalHarga);

                        document.getElementById(
                            "harga_jadwal_bulanan"
                        ).value = new Intl.NumberFormat("id-ID")
                            .format(totalHarga);

                        document.getElementById(
                            "ppn_jadwal_bulanan"
                        ).value = new Intl.NumberFormat("id-ID")
                            .format(ppnResult.ppn);

                        document.getElementById(
                            "grand_total_jadwal_bulanan"
                        ).value = new Intl.NumberFormat("id-ID")
                            .format(ppnResult.grandTotal);

                        // Format hasil tanpa "Rp"
                        const formatted = totalHarga.toLocaleString("id-ID");

                        // Isi hasil ke elemen harga
                        if (
                            hargaEl.tagName === "INPUT" ||
                            hargaEl.tagName === "TEXTAREA"
                        ) {
                            hargaEl.value = formatted;
                        } else {
                            hargaEl.textContent = formatted;
                        }
                    } else {
                        console.warn("⚠️ Data harga mobil kosong");
                    }
                } catch (error) {
                    console.error("🔥 Gagal mengambil harga mobil:", error);
                }
            });

        document
            .getElementById("btnMinusJadwalBulan")
            .addEventListener("click", async function () {
                if (!dynamicMobil.id) {
                    return;
                }

                const lamaSewaEl = document.getElementById(
                    "lamaSewaJadwalBulanan",
                );
                const hargaEl = document.getElementById("harga_jadwal_bulanan");
                const marginEl = document.getElementById("marginJadwalBulanan");

                if (!lamaSewaEl || !hargaEl) {
                    return;
                }

                try {
                    // Kurangi lama sewa (minimal 1)
                    let lamaSewa = parseInt(lamaSewaEl.value || "1");
                    if (lamaSewa > 1) {
                        lamaSewa--;
                    } else {
                        lamaSewa = 1; // batas minimal
                    }
                    lamaSewaEl.value = lamaSewa;

                    // Ambil harga mobil dari API
                    const dataHarga = await cariHargaMobil(
                        dynamicMobil.id,
                        companyIdMain,
                        paramSimpan,
                    );

                    if (dataHarga.length > 0) {
                        const hargaBulanan = parseFloat(
                            dataHarga[0].harga_bulanan || 0,
                        );
                        const margin = parseFloat(marginEl?.value || 0);

                        // Hitung total harga + margin
                        let totalHarga = (hargaBulanan * lamaSewa) + (margin * lamaSewa);

                        const ppnResult = window.calculatePPN(totalHarga);

                        document.getElementById(
                            "harga_jadwal_bulanan"
                        ).value = new Intl.NumberFormat("id-ID")
                            .format(totalHarga);

                        document.getElementById(
                            "ppn_jadwal_bulanan"
                        ).value = new Intl.NumberFormat("id-ID")
                            .format(ppnResult.ppn);

                        document.getElementById(
                            "grand_total_jadwal_bulanan"
                        ).value = new Intl.NumberFormat("id-ID")
                            .format(ppnResult.grandTotal);

                        // Format angka tanpa “Rp”
                        const formatted = totalHarga.toLocaleString("id-ID");

                        // Isi hasil ke elemen harga
                        if (
                            hargaEl.tagName === "INPUT" ||
                            hargaEl.tagName === "TEXTAREA"
                        ) {
                            hargaEl.value = formatted;
                        } else {
                            hargaEl.textContent = formatted;
                        }
                    } else {
                        console.warn("⚠️ Data harga mobil kosong");
                    }
                } catch (error) {
                    console.error("🔥 Gagal mengambil harga mobil:", error);
                }
            });
    } else if (jadwalType === "lepas") {
        document.getElementById("contentPlus").classList.add("hidden");
        document.getElementById("contentBulanan").classList.add("hidden");
        document.getElementById("contentLepas").classList.remove("hidden");

        dateText = modal.querySelector("#modalDateJadwalLepas");
        typeEl = modal.querySelector("#modalTypeJadwalLepas");
        transmissionEl = modal.querySelector("#modalTransmissionJadwalLepas");
        yearEl = modal.querySelector("#modalYearJadwalLepas");
        imageEl = modal.querySelector("#modalImageJadwalLepas");
    }

    fetch("penjadwalan/get-jadwal-show-image-by-type/" + dynamicMobil.id)
        .then((res) => res.json())
        .then((res) => {
            if (res.success) {
                let data = res.data;
                if (imageEl) {
                    let html = data
                        .map((item) => {
                            const imageUrl = item.image_path
                                ? `/${item.image_path}`
                                : "/images/no-image.png";

                            return `
                                <img
                                    src="${imageUrl}"
                                    alt="${item.name || "Image"}"
                                    class="max-h-full object-contain
                                        transition-transform duration-700
                                        ease-in-out hover:scale-105
                                        snap-center rounded-xl shadow-md"
                                />`;
                        })
                        .join("");
                    imageEl.innerHTML = html;
                }
            } else {
                alert("Gagal load data: " + res.message);
            }
        })
        .catch((err) => console.error("Error:", err));

    if (scheduleId) {
        document
            .getElementById("modalDetailInfoJadwal")
            ?.classList.remove("hidden");
        fetch(
            `/penjadwalan/get-jadwal-by-date?order_date=${tanggalStr}&id_type=${dynamicMobil.id}`,
        )
            .then((response) => {
                if (!response.ok) throw new Error("Respon gagal");
                return response.json();
            })
            .then((res) => {
                const data = res.data;

                if (!Array.isArray(data)) {
                    console.warn("Data jadwal tidak dalam format array:", data);
                    return;
                }

                // ========== INFO JADWAL ==========
                const bgColors = [
                    "bg-red-50",
                    "bg-orange-50",
                    "bg-yellow-50",
                    "bg-green-50",
                    "bg-teal-50",
                    "bg-blue-50",
                    "bg-indigo-50",
                    "bg-purple-50",
                    "bg-pink-50",
                ];

                const infoHTML = data
                    .map((item, idx) => {
                        const bgClass = bgColors[idx % bgColors.length];
                        return `
                        <div class="relative min-w-[260px] max-w-[260px] snap-start border border-gray-200 rounded-lg ${bgClass} px-3 py-3 mb-2 shadow-sm hover:shadow-md transition duration-200 text-xs">
                            <div class="font-semibold text-gray-800 text-sm mb-2 truncate">
                                ${idx + 1}. ${item.schedule_code} – ${
                                    item.customer_name
                                        ? (item.customer_name.includes("|")
                                              ? item.customer_name.split("|")[1]
                                              : item.customer_name
                                          ).toUpperCase()
                                        : "-"
                                }
                            </div>
                            <div class="space-y-1.5 text-[11px] text-gray-700">
                                <div class="flex gap-2">
                                    <span class="w-20 font-medium text-gray-600">📅 Order</span>
                                    <span class="flex-1">: ${formatTanggalIndonesia(
                                        item.schedule_date,
                                    )} ${item.schedule_time?.substring(
                                        0,
                                        5,
                                    )}</span>
                                </div>
                                <div class="flex gap-2">
                                    <span class="w-20 font-medium text-gray-600">📅 Selesai</span>
                                    <span class="flex-1">: ${formatTanggalIndonesia(
                                        item.delivery_date,
                                    )} ${formatJam(item.delivery_date)}</span>
                                </div>
                                <div class="flex gap-2">
                                    <span class="w-20 font-medium text-gray-600">🧑‍✈️ Driver</span>
                                    <span class="flex-1">: ${
                                        item.driver_name || "-"
                                    }</span>
                                </div>
                                <div class="flex gap-2">
                                    <span class="w-20 font-medium text-gray-600">📍 Asal</span>
                                    <span class="flex-1">: ${
                                        item.kota_asal || "-"
                                    }</span>
                                </div>
                                <div class="flex gap-2">
                                    <span class="w-20 font-medium text-gray-600">📍 Tujuan</span>
                                    <span class="flex-1">: ${
                                        item.kota_tujuan || "-"
                                    }</span>
                                </div>
                                <div class="flex gap-2">
                                    <span class="w-20 font-medium text-gray-600">🧑‍✈️ Marketer</span>
                                    <span class="flex-1">: ${
                                        item.order_type === "B2B_sharing"
                                            ? item.customer_name
                                                ? (item.customer_name.split(
                                                      "|",
                                                  )[1] ?? item.customer_name)
                                                : "-"
                                            : item.marketing_name || "-"
                                    }</span>
                                </div>
                            </div>

                            <!-- Tombol Reschedule -->
                            <button
                                class="absolute bottom-2 right-2 w-9 h-9 flex items-center justify-center
                                    rounded-full bg-white text-blue-600 shadow-md hover:bg-blue-50
                                    hover:scale-110 transition-all duration-200 ease-out"
                                title="Reschedule"
                                onclick="handleReschedule(${scheduleId}, ${paramSimpan}, ${companyIdMain})"
                            >
                                <i class="fas fa-redo-alt text-sm"></i>
                            </button>
                        </div>
                        `;
                    })
                    .join("");
                document.getElementById("orders-list").innerHTML = infoHTML;

                // ========== HEADER MODAL INFO ==========
                if (idType) idType.value = dynamicMobil.id || "-";
                if (typeEl)
                    typeEl.textContent =
                        selectedMobil.name + " - " + dynamicMobil.name || "-";
                if (transmissionEl)
                    transmissionEl.textContent =
                        dynamicMobil.transmission || "-";
                if (yearEl) yearEl.textContent = dynamicMobil.year || "-";
                if (dateText) dateText.textContent = tanggalStr || "-";
            });
    } else {
        document
            .getElementById("modalDetailInfoJadwal")
            ?.classList.add("hidden");
        if (idType) idType.value = dynamicMobil.id || "-";
        if (typeEl)
            typeEl.textContent =
                selectedMobil.name + " - " + dynamicMobil.name || "-";
        if (transmissionEl)
            transmissionEl.textContent = dynamicMobil.transmission || "-";
        if (yearEl) yearEl.textContent = dynamicMobil.year || "-";
        if (dateText) dateText.textContent = tanggalStr || "-";
    }

    // ========== TAMPILKAN MODAL ==========
    modal.classList.remove("hidden");
    setTimeout(() => {
        if (content) {
            content.classList.remove("scale-0", "opacity-0");
            content.classList.add("scale-100", "opacity-100");
        }

        [typeEl, transmissionEl, yearEl, dateText].forEach((el) => {
            if (el) {
                el.classList.remove("opacity-0", "translate-y-2", "blur-sm");
                el.classList.add("transition-all", "duration-300");
            }
        });
    }, 10);

    initAutocompleteKota();
    initAutocompleteKotaAlamat();

    // ===============================
    // DOM ELEMENTS
    // ===============================
    const inputs = document.querySelectorAll("input, textarea, select");

    function updateInputState() {
        if (chkDalamKotaPenjadwalan.checked) {
            kotaTujuanPenjadwalan.disabled = true;
            kotaTujuanPenjadwalan.placeholder = "";
            kotaTujuanPenjadwalan.value = "";
            lblDalamKotaPenjadwalan.style.color = "blue";
        } else {
            kotaTujuanPenjadwalan.disabled = false;
            kotaTujuanPenjadwalan.placeholder = "Kota Tujuan";
            lblDalamKotaPenjadwalan.style.color = "gray";
        }
    }

    updateInputState();
    chkDalamKotaPenjadwalan.addEventListener("change", updateInputState);

    inputs.forEach((input) => {
        input.addEventListener("focus", () => {
            setTimeout(() => {
                input.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 300);
        });
    });

    // Kosongkan data saat fokus
    document.querySelectorAll("#kotaTujuanPenjadwalan").forEach((el) => {
        el.addEventListener("focus", () => {
            el.value = "";
            el.removeAttribute("data-lat");
            el.removeAttribute("data-lon");
            el.classList.remove("border-red-500");
        });
    });

    document.body.classList.add("overflow-hidden");

    ["alamat"].forEach((id) => {
        document.getElementById(id)?.addEventListener("blur", async () => {
            const asalJemput = document.getElementById("alamat");
            const tujuanJemput = document.getElementById("kotaTujuanPenjadwalan");
            if (asalJemput?.value && tujuanJemput?.value) {
                try {
                    await getCoordinates(asalJemput);
                    await getCoordinates(tujuanJemput);

                    document.dispatchEvent(
                        new CustomEvent("penjadwalanCoordsUpdatedJemput", {
                            detail: {
                                latAsalJemput: parseFloat(
                                    asalJemput.dataset.lat,
                                ),
                                lonAsalJemput: parseFloat(
                                    asalJemput.dataset.lon,
                                ),
                                latTujuanJemput: parseFloat(
                                    tujuanJemput.dataset.lat,
                                ),
                                lonTujuanJemput: parseFloat(
                                    tujuanJemput.dataset.lon,
                                ),
                            },
                        }),
                    );
                } catch (err) {
                    handleDistanceError(err);
                }
            }
        });
    });

    if (tanggalStr) {
        const tanggalStrObj = new Date(tanggalStr);
        tanggalStrObj.setHours(23, 59, 0, 0);

        if (tanggalSampai._flatpickr) {
            tanggalSampai._flatpickr.set("minDate", tanggalStrObj);
            tanggalSampai._flatpickr.setDate(tanggalStrObj, true);
        } else {
            flatpickr(tanggalSampai, {
                enableTime: true,
                time_24hr: true,
                dateFormat: "Y-m-d H:i",
                minDate: tanggalStrObj,
                defaultDate: tanggalStrObj,
                locale: "id",
            });
        }

        if (tanggalSampaiLepas._flatpickr) {
            tanggalSampaiLepas._flatpickr.set("minDate", tanggalStrObj);
            tanggalSampaiLepas._flatpickr.setDate(tanggalStrObj, true);
        } else {
            flatpickr(tanggalSampaiLepas, {
                enableTime: true,
                time_24hr: true,
                dateFormat: "Y-m-d H:i",
                minDate: tanggalStrObj,
                defaultDate: tanggalStrObj,
                locale: "id",
            });
        }
    }

    let isProcessingRental = false;
    // listener PPN
    document
        .getElementById("ppnFilter")
        ?.addEventListener("change", () => {

            // PLUS
            document
                .getElementById("tanggal_sampai")
                ?.dispatchEvent(new Event("change"));

            // LEPAS
            document
                .getElementById("tanggal_sampai_lepas")
                ?.dispatchEvent(new Event("change"));

            // BULANAN
            document
                .getElementById("lamaSewaJadwalBulanan")
                ?.dispatchEvent(new Event("change"));

            document
                .getElementById("marginJadwalBulanan")
                ?.dispatchEvent(new Event("change"));
        });

    tanggalSampai.addEventListener("change", async (e) => {
        e.stopImmediatePropagation();
        if (isProcessingRental) return;

        try {
            isProcessingRental = true;
            const kotaTujuanValue = document.getElementById("kotaTujuanPenjadwalan")?.value || "";
            const selectedType = document.getElementById("jadwalSelectedType").value;
            const tanggalEl = document.getElementById("modalDateJadwal");
            const jamEl = document.getElementById("jam");
            const chkDalamKotaPenjadwalan = document.getElementById("chkDalamKotaPenjadwalan");
            const tanggalValue = tanggalEl ? tanggalEl.textContent.trim() : "";
            const jamValue = jamEl ? jamEl.value : "";
            const orderDate = `${tanggalValue} ${jamValue}`;
            const orderDateObj = new Date(orderDate);
            const deliveryDateObj = new Date(tanggalSampai.value);
            const margin = document.getElementById("margin").value || 0;
            document.querySelectorAll(".flatpickr-input").forEach((el) => {
                if (el._flatpickr) el._flatpickr.close();
            });

            if (orderDateObj > deliveryDateObj) {
                Swal.fire({
                    icon: "error",
                    title: "Tanggal Tidak Valid",
                    text: "Tanggal checkout tidak boleh lebih awal dari order date!",
                });
                isProcessingRental = false;
                return;
            }

            let kotaTujuan = chkDalamKotaPenjadwalan.checked
                ? window.companyCity
                : kotaTujuanValue;

            const costPelayanan = [];

            document
                .querySelectorAll('input[name="costPelayanan[]"]:checked')
                .forEach(el => {
                    costPelayanan.push(parseInt(el.value));
                });

            console.log('costPelayanan:', costPelayanan);

            const result = await fetchRentalPrice({
                distance: typeof distanceKm !== "undefined" ? distanceKm : 0,
                carId: dynamicMobil?.id,
                orderDate: orderDate,
                deliveryDate: tanggalSampai.value,
                kotaAsal: window.companyCity,
                kotaTujuan: kotaTujuan,

                costPelayanan: costPelayanan,

                inap: 0,
                biayaMakan: 0,
                biayaBuah: 0,
                biayaBunga: 0,
                biayaParcel: 0,
                biayaDekorasi: 0,
            });

            if (result) {
                let totalHarga = 0;
                const {
                    lama_hari,
                    lama_jam,
                    price_bulanan,
                    v_car_lepas_kunci,
                    price_dalam_kota,
                    v_car_luar,
                    v_bbm_dalam_kota,
                    v_bbm_luar_kota,
                    v_biaya_3_jam,
                    v_biaya_6_jam,
                    v_biaya_9_jam,
                    v_biaya_12_jam,
                } = result;

                const lamaHari = parseInt(lama_hari);
                const lamaJam = parseInt(lama_jam);
                const priceDalam = parseFloat(price_dalam_kota);

                if (selectedType === "plus") {

                    if (chkDalamKotaPenjadwalan.checked) {

                        if (lamaHari === 0) {

                            if (lamaJam <= 3)
                                totalHarga = (v_biaya_3_jam / 100) * priceDalam;

                            else if (lamaJam <= 6)
                                totalHarga = (v_biaya_6_jam / 100) * priceDalam;

                            else if (lamaJam <= 9)
                                totalHarga = (v_biaya_9_jam / 100) * priceDalam;

                            else if (lamaJam <= 12)
                                totalHarga = (v_biaya_12_jam / 100) * priceDalam;

                            else
                                totalHarga = priceDalam;

                        } else {

                            totalHarga =
                                parseFloat(price_dalam_kota || 0) +
                                parseFloat(v_bbm_dalam_kota || 0);

                        }

                    } else {

                        totalHarga =
                            parseFloat(result.price_luar_kota || 0);

                    }

                }
                else if (selectedType === "lepas") {
                    totalHarga = parseFloat(v_car_lepas_kunci) * (lamaHari || 1);
                } else if (selectedType === "bulanan") {
                    totalHarga = parseFloat(price_bulanan);
                }

                let gdTotalHarga = totalHarga + parseFloat(margin);

                // =====================================
                // BIAYA TAMBAHAN
                // =====================================

                let totalAdditionalCost = 0;

                document
                    .querySelectorAll('input[name="costPelayanan[]"]:checked')
                    .forEach(el => {

                        const costId = parseInt(el.value);

                        // BBM
                        if (costId === 1) {
                            return;
                        }

                        const amountInput = document.querySelector(
                            `input[name="cost_amount[${costId}]"]`
                        );

                        if (amountInput) {
                            totalAdditionalCost +=
                                parseFloat(amountInput.value || 0);
                        }
                    });

                gdTotalHarga += totalAdditionalCost;

                const ppnResult = window.calculatePPN(gdTotalHarga);

                window.currentSubtotal = gdTotalHarga;
                window.currentPPN = ppnResult.ppn;
                window.currentGrandTotal = ppnResult.grandTotal;

                document.getElementById(
                    "harga_penjadwalan"
                ).value = new Intl.NumberFormat("id-ID")
                    .format(window.currentSubtotal);

                document.getElementById(
                    "ppn_penjadwalan"
                ).value = new Intl.NumberFormat("id-ID")
                    .format(window.currentPPN);

                document.getElementById(
                    "grand_total_penjadwalan"
                ).value = new Intl.NumberFormat("id-ID")
                    .format(window.currentGrandTotal);
            }
        } catch (err) {
            console.error("Gagal fetch rental price:", err);
        } finally {
            isProcessingRental = false;
        }
    });

    tanggalSampaiLepas.addEventListener("change", async () => {
        try {
            const tanggalElLepas = document.getElementById(
                "modalDateJadwalLepas",
            );

            // Ambil nilai tanggal mulai
            const tanggalValue = tanggalElLepas
                ? tanggalElLepas.textContent.trim()
                : "";
            if (!tanggalValue) {
                console.warn(
                    "Tanggal mulai tidak ditemukan di modalDateJadwalLepas",
                );
                return;
            }

            const orderDateLepas = new Date(tanggalValue);
            const deliveryDateLepas = new Date(tanggalSampaiLepas.value);

            // Tutup semua flatpickr yang masih terbuka
            document.querySelectorAll(".flatpickr-input").forEach((el) => {
                if (el._flatpickr) el._flatpickr.close();
            });

            // Ambil margin
            const marginEl = document.getElementById("marginJadwalLepas");
            const marginLepas = marginEl ? Number(marginEl.value) || 0 : 0;

            // Validasi tanggal
            if (orderDateLepas > deliveryDateLepas) {
                Swal.fire({
                    icon: "error",
                    title: "Tanggal Tidak Valid",
                    text: "Tanggal checkout tidak boleh lebih awal dari order date!",
                });
                return;
            }

            // Pastikan ada ID mobil
            if (!dynamicMobil?.id) {
                console.warn(
                    "ID mobil tidak ditemukan (dynamicMobil?.id null)",
                );
                return;
            }

            // Ambil data harga dari backend
            const result = await getCarTypesByCompanyId(
                dynamicMobil.id,
                tanggalStr,
                deliveryDateLepas,
            );

            // Karena result berupa array
            if (Array.isArray(result) && result.length > 0) {
                const data = result[0]; // ambil object pertama dari array
                const lamaHari = Number(data.lama_hari) || 0;
                const hargaPerHari = Number(data.harga) || 0;

                const totalHarga = hargaPerHari * lamaHari;
                // const totalMargin = marginLepas * lamaHari;

                // DPP = harga + margin
                const dpp = totalHarga + marginLepas;

                // hitung ppn dari DPP
                const ppnResult = window.calculatePPN(dpp);

                document.getElementById(
                    "harga_jadwal_lepas"
                ).value = new Intl.NumberFormat("id-ID")
                    .format(dpp);

                document.getElementById(
                    "ppn_jadwal_lepas"
                ).value = new Intl.NumberFormat("id-ID")
                    .format(ppnResult.ppn);

                document.getElementById(
                    "grand_total_jadwal_lepas"
                ).value = new Intl.NumberFormat("id-ID")
                    .format(ppnResult.grandTotal);

                // simpan ke global untuk submit
                window.currentSubtotal = dpp;
                window.currentPPN = ppnResult.ppn;
                window.currentGrandTotal = ppnResult.grandTotal;

                // Format ke rupiah
                const formattedHarga = new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    minimumFractionDigits: 0,
                }).format(grandTotal);
                document.getElementById("harga_jadwal_lepas").value =
                    formattedHarga;
            } else {
                document.getElementById("harga_jadwal_lepas").value = "Rp 0";
            }
        } catch (err) {
            console.error("Gagal fetch rental price:", err);
        }
    });

    // Tambah animasi masuk
    setTimeout(() => {
        if (content) {
            content.classList.remove("scale-95", "opacity-0", "translate-y-10");
            content.classList.add("scale-100", "opacity-100", "translate-y-0");
        }

        if (modal) {
            modal.classList.remove("opacity-0", "translate-y-2", "blur-sm");
            modal.classList.add(
                "opacity-100",
                "translate-y-0",
                "transition-all",
                "duration-300",
                "ease-out",
            );
        }
    }, 10);
}

export function closeModalPenjadwalan(modalId) {
    const modal = document.getElementById(modalId);
    const content = modal?.querySelector("#modalContentJadwal");
    const nameEl = modal?.querySelector("#modalNameJadwal");
    const cityEl = modal?.querySelector("#modalCityJadwal");
    const dateText = modal?.querySelector("#modalDateJadwal");

    if (!modal || !content) return;

    // Tambah animasi keluar
    content.classList.remove("scale-100", "opacity-100");
    content.classList.add("scale-0", "opacity-0");

    // Sembunyikan teks langsung (biar nggak kelihatan blur sebelum hilang)
    [nameEl, cityEl, dateText].forEach((el) => {
        if (el) {
            el.style.visibility = "hidden";
        }
    });

    // Delay untuk nunggu animasi selesai (500ms)
    setTimeout(() => {
        modal.classList.add("hidden");

        // Reset class dan isi untuk show berikutnya
        [nameEl, cityEl, dateText].forEach((el) => {
            if (el) {
                el.textContent = "";
                el.classList.remove("opacity-100", "translate-y-0", "blur-0");
                el.classList.add("opacity-0", "translate-y-2", "blur-sm");
                el.style.visibility = "visible";
            }
        });

        resetPenjadwalan();
        resetDistanceInputs(
            "kotaPenjemputanPenjadwalan",
            "kotaTujuanPenjadwalan",
        );
        resetModalJadwal();
        // Reset konten modal
        content.classList.remove("scale-0", "opacity-0");
        content.classList.add("scale-100", "opacity-100");

        // Nonaktifkan scrolling halaman & form belakangnya
        document.body.classList.remove("overflow-hidden");
    }, 500);
}

function formatTanggalIndonesia(tanggalStr) {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const dateObj = new Date(tanggalStr);
    return dateObj.toLocaleDateString("id-ID", options);
}

function formatJam(tanggalStr) {
    const dateObj = new Date(tanggalStr);
    return dateObj.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit",
    });
}

function formatRupiah(number) {
    if (!number) return "";
    return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
    }).format(number);
}

// Buka bottom sheet
export function openBottomSheet(scheduleId, paramSimpan, companyIdMain) {
    const bottomSheet = document.getElementById("bottomSheet");
    const overlay = document.getElementById("bottomSheetOverlay");

    if (!bottomSheet || !overlay) {
        return;
    }

    let idKategori;
    let idType;
    fetch(`/penjadwalan/get-jadwal-by-id-single?id=${scheduleId}`)
        .then((res) => res.json())
        .then((res) => {
            if (res && res.length > 0) {
                const jadwal = res[0];
                idKategori = jadwal.category_id;
                idType = jadwal.car_type_id;

                document.getElementById("bottomSheetTitle").textContent =
                    jadwal.schedule_code || "";
                // --- Data Asli ---
                document.getElementById("scheduleId").value =
                    jadwal.jadwal_id || "";
                document.getElementById("namaAsli").value =
                    jadwal.customer_name || "";
                document.getElementById("telpAsli").value =
                    jadwal.customer_phone || "";
                document.getElementById("alamatAsli").value =
                    jadwal.customer_address || "";
                document.getElementById("kotaAsalAsli").value =
                    jadwal.kota_asal || "";
                document.getElementById("kotaTujuanAsli").value =
                    jadwal.tujuan || "";
                document.getElementById("nama_driverAsli").value =
                    jadwal.driver_name || "";
                document.getElementById("jamAsli").value =
                    jadwal.jam || "06:00";
                document.getElementById("alamat_jemputAsli").value =
                    jadwal.alamat_jemput || "";
                document.getElementById("marginAsli").value =
                    jadwal.margin || "";
                document.getElementById("harga_penjadwalanAsli").value =
                    formatRupiah(jadwal.harga);
                if (jadwal.delivery_date) {
                    const dateObj = new Date(
                        jadwal.delivery_date.replace(" ", "T"),
                    );
                    if (
                        window.flatpickrInstances &&
                        window.flatpickrInstances["tanggal_sampaiAsli"]
                    ) {
                        window.flatpickrInstances["tanggal_sampaiAsli"].setDate(
                            dateObj,
                            true,
                        );
                    } else {
                        window.flatpickrInstances =
                            window.flatpickrInstances || {};
                        window.flatpickrInstances["tanggal_sampaiAsli"] =
                            flatpickr("#tanggal_sampaiAsli", {
                                enableTime: true,
                                time_24hr: true,
                                dateFormat: "d-m-Y H:i",
                                defaultDate: dateObj,
                            });
                    }
                }

                // --- Data Reschedule (duplicate dari Asli) ---
                document.getElementById("nama_driverReschedule").value =
                    jadwal.driver_id || "";
                document.getElementById("tanggal_jemputReschedule").value =
                    jadwal.tanggal || "";
                document.getElementById("jamReschedule").value =
                    jadwal.jam || "06:00:00";
                document.getElementById("tanggal_sampaiReschedule").value =
                    jadwal.delivery_date || "";

                if (jadwal.tanggal) {
                    const dateObjRes = new Date(
                        jadwal.tanggal.replace(" ", "T"),
                    );
                    if (
                        window.flatpickrInstances &&
                        window.flatpickrInstances["tanggal_jemputReschedule"]
                    ) {
                        window.flatpickrInstances[
                            "tanggal_jemputReschedule"
                        ].setDate(dateObjRes, true);
                    } else {
                        window.flatpickrInstances =
                            window.flatpickrInstances || {};
                        window.flatpickrInstances["tanggal_jemputReschedule"] =
                            flatpickr("#tanggal_jemputReschedule", {
                                dateFormat: "d-m-Y",
                                defaultDate: dateObjRes,
                            });
                    }
                }

                if (jadwal.delivery_date) {
                    const dateObjRes = new Date(
                        jadwal.delivery_date.replace(" ", "T"),
                    );
                    if (
                        window.flatpickrInstances &&
                        window.flatpickrInstances["tanggal_sampaiReschedule"]
                    ) {
                        window.flatpickrInstances[
                            "tanggal_sampaiReschedule"
                        ].setDate(dateObjRes, true);
                    } else {
                        window.flatpickrInstances =
                            window.flatpickrInstances || {};
                        window.flatpickrInstances["tanggal_sampaiReschedule"] =
                            flatpickr("#tanggal_sampaiReschedule", {
                                enableTime: true,
                                time_24hr: true,
                                dateFormat: "d-m-Y H:i",
                                defaultDate: dateObjRes,
                            });
                    }
                }

                // 1. Cek koordinat
                if (
                    !jadwal.asal_lat ||
                    !jadwal.asal_lon ||
                    !jadwal.tujuan_lat ||
                    !jadwal.tujuan_lon
                ) {
                    document.getElementById("mapReschedule").innerHTML =
                        "<p class='text-red-500 text-sm'>Koordinat tidak tersedia</p>";
                } else {
                    // 2. Reset map container
                    const mapContainer =
                        document.getElementById("mapReschedule");
                    if (mapContainer) {
                        mapContainer.innerHTML = "";
                        mapContainer._leaflet_id = null;
                    }
                    // 3. Tampilkan peta
                    tampilkanPetaSingleTrip({
                        latAsal: jadwal.asal_lat,
                        lonAsal: jadwal.asal_lon,
                        latTujuan: jadwal.tujuan_lat,
                        lonTujuan: jadwal.tujuan_lon,
                        mapId: "mapReschedule",
                    });
                }

                getDistanceFromCoords([
                    {
                        latAsal: parseFloat(jadwal.asal_lat),
                        lonAsal: parseFloat(jadwal.asal_lon),
                        latTujuan: parseFloat(jadwal.tujuan_lat),
                        lonTujuan: parseFloat(jadwal.tujuan_lon),
                        asalText: jadwal.kota_asal,
                        tujuanText: jadwal.kota_tujuan,
                        output: "outputJarakReschedulePenjadwalan",
                    },
                ]).then(([jarak]) => {
                    document.getElementById(
                        "outputJarakReschedulePenjadwalan",
                    ).innerHTML = `
                        <span class="text-blue-700">Jarak: ${jarak.toFixed(
                            1,
                        )}</span>
                    `;
                });

                loadDriver();
                loadKategoriUnit(idKategori, idType);
            }
        })
        .catch((err) => {
            console.error(err);
            orders.innerHTML = `<p class="text-red-500">Error fetch data</p>`;
        });

    overlay.classList.remove("hidden");
    bottomSheet.classList.remove("hidden");

    setTimeout(() => {
        bottomSheet.classList.remove("translate-y-full");
    }, 10);
}

export function closeBottomSheet() {
    const bottomSheet = document.getElementById("bottomSheet");
    const overlay = document.getElementById("bottomSheetOverlay");

    if (!bottomSheet || !overlay) return;

    bottomSheet.classList.add("translate-y-full");
    overlay.classList.add("hidden");

    setTimeout(() => {
        bottomSheet.classList.add("hidden");
    }, 300);
}

window.handleReschedule = function (scheduleId, paramSimpan, companyIdMain) {
    openBottomSheet(scheduleId, paramSimpan, companyIdMain);
};
window.closeBottomSheet = closeBottomSheet;

function loadKategoriUnit(idKategori, idType) {
    const kategoriSelect = document.getElementById("kategoriUnitPenjadwalan");
    fetch("/penjadwalan/get-category-unit-edit")
        .then((response) => response.json())
        .then((data) => {
            // 1. Bersihkan option lama
            kategoriSelect.querySelectorAll('option:not([value=""])').forEach((el) => el.remove());

            // 2. Isi option baru
            data.forEach((item) => {
                const option = document.createElement("option");
                option.value = item.id;
                option.textContent = item.name;
                if (item.id == idKategori) option.selected = true;
                kategoriSelect.appendChild(option);
            });

            // 3. INI KUNCINYA: Hanya load tipe jika idKategori ada
            // DAN pastikan tidak dipanggil berulang di tempat lain.
            if (idKategori) {
                loadTypeKategoriUnit(idKategori, idType);
            }
        });

    // 4. Gunakan handler tunggal untuk perubahan manual oleh user
    kategoriSelect.onchange = function () {
        const val = this.value;
        if (val) {
            loadTypeKategoriUnit(val, null);
        }
    };
}

export function loadTypeKategoriUnit(selectedValue, idType) {
    const typeUnit = document.getElementById("typeUnit");
    fetch(`/penjadwalan/get-type-category-unit-edit?id=${selectedValue}`)
        .then((response) => response.json())
        .then((data) => {
            typeUnit
                .querySelectorAll('option:not([value=""])')
                .forEach((el) => el.remove());
            data.forEach((item) => {
                const option = document.createElement("option");
                option.value = item.car_type_id;
                option.textContent = `${item.car_type_name} - ${item.plat_nomor}`;
                if (item.car_type_id == idType) {
                    option.selected = true;
                }

                typeUnit.appendChild(option);
            });
        })
        .catch((err) => {
            console.error("Gagal mengambil tipe unit:", err);
        });
}

function loadDriver() {
    const driverSelect = document.getElementById("nama_driverReschedule");

    fetch("/penjadwalan/get-driver-unit-edit")
        .then((response) => response.json())
        .then((data) => {
            driverSelect
                .querySelectorAll('option:not([value=""])')
                .forEach((el) => el.remove());
            data.forEach((item) => {
                const option = document.createElement("option");
                option.value = item.driver_id;
                option.textContent = item.user_name;
                driverSelect.appendChild(option);
            });
        })
        .catch((err) => {
            console.error("Gagal mengambil kategori unit:", err);
        });

    driverSelect.addEventListener("change", function () {
        const selectedValue = this.value;
    });
}

function formatDateToMySQL(dateStr) {
    let parts = dateStr.split("/");
    if (parts.length === 3) {
        return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(
            2,
            "0",
        )}`;
    }
    return dateStr;
}

export function initReschedule() {
    const btn = document.querySelector("#saveReschedule");

    if (!btn) return;

    btn.addEventListener("click", async function (e) {
        e.preventDefault();

        const scheduleId = document.querySelector("#scheduleId").value;
        const driverId = document.querySelector("#nama_driverReschedule").value;
        const tanggal = formatDateToMySQL(
            document.querySelector("#tanggal_jemputReschedule").value,
        );
        const jam = document.querySelector("#jamReschedule").value;
        const deliveryDate = formatDateToMySQL(
            document.querySelector("#tanggal_sampaiReschedule").value,
        );
        const idCarType = document.querySelector("#typeUnit").value;

        if (!scheduleId || !tanggal || !jam || !idCarType) {
            Swal.fire({
                icon: "warning",
                title: "Oops...",
                text: "Semua field wajib diisi!",
                confirmButtonText: "Ok",
            });

            return;
        }

        const data = {
            schedule_id: scheduleId,
            tanggal: tanggal,
            jam: jam,
            delivery_date: deliveryDate,
            id_car_type: idCarType,
            driver_id: driverId,
        };
        try {
            btn.disabled = true;
            Swal.fire({
                title: "Memproses...",
                text: "Harap tunggu sebentar",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            const res = await fetch("/penjadwalan/update-reschedule", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    "X-CSRF-TOKEN": document
                        .querySelector('meta[name="csrf-token"]')
                        .getAttribute("content"),
                },
                body: JSON.stringify(data),
            });

            const result = await res.json();

            if (res.ok) {
                Swal.close();
                Swal.fire({
                    icon: "success",
                    title: "Data Tersimpan!",
                    text: result.message,
                    timer: 2000,
                    showConfirmButton: false,
                    timerProgressBar: true,
                });
                resetPenjadwalan();
                refreshJadwalBulanAktif();

                const modal = document.getElementById("modalJadwal");
                modal?.classList.add("hidden");
                document.body.classList.remove("overflow-hidden");

                const content = modal?.querySelector("#modalContentJadwal");
                if (content) {
                    content.classList.remove("scale-0", "opacity-0");
                    content.classList.add("scale-100", "opacity-100");
                }
                const kotaInput = document.getElementById("kotaPenjemputanPenjadwalan");

                    if (kotaInput) {
                        kotaInput.value = window.companyCity || "";
                    }
                closeBottomSheet();
            } else {
                alert(
                    result.message || "Terjadi kesalahan, silakan coba lagi.",
                );
            }
        } catch (err) {
            console.error(err);
            alert("Terjadi kesalahan, silakan coba lagi.");
        } finally {
            btn.disabled = false;
            btn.textContent = "Submit";
        }
    });
}

export async function getCarTypesByCompanyId(id, tanggalOrder, tanggalSelesai) {
    const tglOrder = toYMD(tanggalOrder);
    const tglSelesai = toYMD(tanggalSelesai);

    try {
        const response = await axios.get("/penjadwalan/car-types", {
            params: {
                id,
                tanggalOrder: tglOrder,
                tanggalSelesai: tglSelesai,
            },
        });

        if (response.data.success) {
            return response.data.data;
        } else {
            console.error("Gagal:", response.data.message);
            return null;
        }
    } catch (error) {
        console.error("Gagal memuat data car types:", error);
        return null;
    }
}

async function cariHargaMobil(id, companyIdMain, paramSimpan) {
    try {
        const response = await fetch(
            `/penjadwalan/get-harga-car-types-company?id=${id}&companyIdMain=${companyIdMain}&paramSimpan=${paramSimpan}`,
            {
                headers: {
                    Accept: "application/json",
                },
            },
        );

        if (!response.ok) {
            throw new Error("Gagal mengambil data dari server");
        }

        const result = await response.json();

        if (result.success) {
            return result.data;
        } else {
            return [];
        }
    } catch (err) {
        return [];
    }
}

window.tollManager = window.tollManager || {
    timer: null,
    lastSuccessKey: "",
    pendingKey: "",
    requestId: 0,
};

document.addEventListener("penjadwalanCoordsUpdatedJemput", async (e) => {
    const { latAsalJemput, lonAsalJemput, latTujuanJemput, lonTujuanJemput } = e.detail;
    if (!latAsalJemput || !latTujuanJemput) return;

    const currentKey = `${Number(latAsalJemput).toFixed(4)}|${Number(lonAsalJemput).toFixed(4)}|${Number(latTujuanJemput).toFixed(4)}|${Number(lonTujuanJemput).toFixed(4)}`;

    if (currentKey === window.tollManager.lastSuccessKey || currentKey === window.tollManager.pendingKey) {
        return;
    }

    const mapEl = document.getElementById("mapPenjadwalan");
    const asal = document.getElementById("alamat");
    const tujuan = document.getElementById("kotaTujuanPenjadwalan");

    if (asal?.value && tujuan?.value) {
        try {
            const pairs = [{
                asal: asal.id,
                tujuan: tujuan.id,
                output: "outputJarakPenjadwalan",
            }];

            const [jarak] = await getDistanceFromInputs(pairs);
            distanceKm = jarak;
            console.log("Jarak:", distanceKm, "km");
        } catch (error) {
            console.error("Gagal menghitung jarak:", error);
        }
    }

    if (mapEl) mapEl.classList.remove("hidden");
    tampilkanPetaSingleTrip({
        latAsal: parseFloat(latAsalJemput),
        lonAsal: parseFloat(lonAsalJemput),
        latTujuan: parseFloat(latTujuanJemput),
        lonTujuan: parseFloat(lonTujuanJemput),
        mapId: "mapPenjadwalan",
    });

    if (window.tollManager.timer) clearTimeout(window.tollManager.timer);

    window.tollManager.pendingKey = currentKey;
    window.tollManager.timer = setTimeout(() => {
        handleTollFetch(e.detail, currentKey);
    }, 1000);
});

async function handleTollFetch(coords, currentKey) {
    const thisId = ++window.tollManager.requestId;
    const totalTollDistanceEl = document.getElementById("totalTollDistance");
    const listTollHiddenEl = document.getElementById("listTollPenjadwalan");

    const { isConfirmed } = await Swal.fire({
        title: "Gunakan Rute Tol?",
        html: `
            <p class="text-sm text-slate-500">
                Aksi ini membutuhkan waktu sejenak untuk menghubungkan ke layanan pemetaan dan tarif tol.
            </p>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Hitung Rute",
        cancelButtonText: "Lewati",
        confirmButtonColor: "#4f46e5",
        cancelButtonColor: "#64748b",
        customClass: {
            popup: "rounded-[1.5rem]",
            title: "text-lg font-bold",
        },
    });

    if (!isConfirmed) return;

    Swal.fire({
        title: "Mengkalkulasi Rute",
        html: `
            <div class="flex flex-col items-center py-2">
                <div class="relative w-16 h-16 mb-6">
                    <div class="absolute inset-0 border-4 border-indigo-100 rounded-full"></div>
                    <div class="absolute inset-0 border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
                    <div class="absolute inset-0 flex items-center justify-center">
                        <i class="fa-solid fa-route text-indigo-600 animate-pulse"></i>
                    </div>
                </div>
                <p class="text-sm font-medium text-slate-600 tracking-tight">
                    Menghubungkan ke satelit...
                </p>
                <p class="text-[11px] text-slate-400 mt-1 uppercase tracking-[0.2em] font-bold">
                    Optimasi Gerbang Tol
                </p>
            </div>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        width: "380px",
        padding: "2rem",
        background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
        showClass: {
            popup: "animate-swal-show",
        },
        hideClass: {
            popup: "animate-swal-hide",
        },
        customClass: {
            popup: "modern-swal-popup",
            title: "modern-swal-title",
        },
        didOpen: () => {
            Swal.hideLoading();
        },
    });

    try {
        if (totalTollDistanceEl) {
            totalTollDistanceEl.innerHTML = `
                <div class="flex items-center gap-2 text-[10px] p-2 text-indigo-500">
                    <i class="fa-solid fa-circle-notch fa-spin"></i>
                    <span>Mengecek Toll...</span>
                </div>`;
        }

        // Jalankan Fetch
        const [resAsal, resTujuan] = await Promise.all([
            fetch(
                `/cari-toll-terdekat?lat=${coords.latAsalJemput}&lon=${coords.lonAsalJemput}`,
            ),
            fetch(
                `/cari-toll-terdekat?lat=${coords.latTujuanJemput}&lon=${coords.lonTujuanJemput}`,
            ),
        ]);

        if (thisId !== window.tollManager.requestId) return;
        if (!resAsal.ok || !resTujuan.ok) {
            throw new Error(
                `Server Error (${resAsal.status}/${resTujuan.status})`,
            );
        }

        const dataAsal = await resAsal.json();
        const dataTujuan = await resTujuan.json();

        if (dataAsal.nearest?.length && dataTujuan.nearest?.length) {
            window.tollManager.lastSuccessKey = currentKey;
            window.tollManager.pendingKey = "";
            console.log("ASAL", dataAsal.nearest[0]);
            console.log("TUJUAN", dataTujuan.nearest[0]);
            renderTollData(
                dataAsal.nearest[0],
                dataTujuan.nearest[0],
                totalTollDistanceEl,
                listTollHiddenEl,
            );
            setTimeout(() => {
                Swal.close();
            }, 300);
        } else {
            throw new Error("Rute tidak didukung");
        }
    } catch (err) {
        window.tollManager.pendingKey = "";
        Swal.close();
        Swal.fire({
            icon: "info",
            title: "Info Rute",
            text: "Rute tol tidak ditemukan atau server sedang sibuk. Silahkan coba lagi nanti atau masukkan tarif toll secara manual.",
            timer: 3000,
            showConfirmButton: false,
        });

        if (totalTollDistanceEl) {
            totalTollDistanceEl.innerHTML = `
                <div class="text-[10px] text-red-500 p-2 italic bg-red-50 rounded-lg border border-red-100">
                    <i class="fa-solid fa-triangle-exclamation mr-1"></i> Gagal memuat data toll.
                </div>`;
        }
        window.tarifTol = 0;
    }
}

function renderTollData(asal, tujuan, container, hidden) {
    if (!asal || !tujuan || !container) return;

    asal.lat = parseFloat(asal.lat);
    asal.lon = parseFloat(asal.lon);
    tujuan.lat = parseFloat(tujuan.lat);
    tujuan.lon = parseFloat(tujuan.lon);

    if (isNaN(asal.lat) || isNaN(tujuan.lat)) return;

    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;

    const dLat = toRad(tujuan.lat - asal.lat);
    const dLon = toRad(tujuan.lon - asal.lon);

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(asal.lat)) *
            Math.cos(toRad(tujuan.lat)) *
            Math.sin(dLon / 2) ** 2;

    const dist = R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const price = Math.round(dist * 1000);

    if (isNaN(dist)) return;

    container.innerHTML = `
        <div class="animate-toll-card relative overflow-hidden bg-white/80 backdrop-blur-sm border border-indigo-50 rounded-2xl p-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:shadow-md">
            <div class="absolute left-0 top-0 bottom-0 w-1 bg-indigo-500"></div>

            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-3">
                    <div class="flex flex-col items-center gap-1">
                        <div class="w-2 h-2 rounded-full bg-indigo-500"></div>
                        <div class="w-[1px] h-4 border-l border-dashed border-gray-300"></div>
                        <div class="w-2 h-2 rounded-full border-2 border-indigo-500 bg-white"></div>
                    </div>

                    <div class="flex flex-col">
                        <span class="text-[10px] leading-none text-gray-400 font-medium uppercase tracking-wider">Estimasi Rute Tol</span>
                        <div class="flex items-center gap-2 mt-1">
                            <span class="text-[12px] font-bold text-slate-800 tracking-tight">${asal.name}</span>
                            <i class="fa-solid fa-chevron-right text-[8px] text-indigo-300"></i>
                            <span class="text-[12px] font-bold text-slate-800 tracking-tight">${tujuan.name}</span>
                        </div>
                    </div>
                </div>

                <div class="flex items-center justify-between pt-3 border-t border-gray-50">
                    <div class="flex items-center gap-1.5 bg-indigo-50 px-2 py-1 rounded-lg">
                        <i class="fa-solid fa-route text-indigo-500 text-[10px]"></i>
                        <span class="text-[11px] text-indigo-700 font-bold">${dist.toFixed(1)} km</span>
                    </div>

                    <div class="text-right">
                        <span class="block text-[9px] text-gray-400 leading-none mb-1 font-medium">Total Tarif</span>
                        <span class="text-[14px] font-black text-slate-900 tracking-tight">
                            <span class="text-[10px] font-bold mr-0.5">Rp</span>${price.toLocaleString("id-ID")}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    `;

    if (hidden) {
        hidden.value = JSON.stringify({
            asalToll: asal,
            tujuanToll: tujuan,
            totalDistanceKm: dist,
            tollPrice: price,
        });
    }
    window.tarifTol = price;
}

function toYMD(val) {
    if (!val) return null;

    const d = val instanceof Date ? val : new Date(val);
    if (isNaN(d.getTime())) return null;

    return d.toISOString().slice(0, 10);
}

export function resetDistanceInputs(asalId, tujuanId) {
    [asalId, tujuanId].forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;

        el.value = "";
        delete el.dataset.lat;
        delete el.dataset.lon;
    });
}

async function loadPaymentMethods() {

    const container = document.getElementById('paymentMethodsContainer');
    const hiddenInput = document.getElementById('selected_payment_method_id');

    try {

        const response = await fetch('/penjadwalan/get-payment-methods');
        const result = await response.json();

        if (result.success && result.data.length > 0) {

            container.innerHTML = '';

            result.data.forEach(method => {

                const methodCard = document.createElement('div');

                methodCard.className = `
                    relative flex items-center justify-between p-3 rounded-xl border-2
                    cursor-pointer transition-all duration-200 hover:bg-indigo-50 border-gray-100
                `;

                methodCard.dataset.id = method.id;
                methodCard.dataset.value = method.id;

                methodCard.innerHTML = `
                    <div class="flex flex-col w-full gap-2">
                        <div class="flex items-center justify-between w-full">

                            <div class="flex items-center gap-3">

                                <div class="w-10 h-10 rounded-lg bg-white border border-gray-100 flex items-center justify-center text-indigo-600">
                                    <i class="${method.type === 'QRIS' ? 'fas fa-qrcode' : 'fas fa-money-bill-wave'}"></i>
                                </div>

                                <div>
                                    <div class="text-xs font-bold text-gray-800">${method.name}</div>
                                </div>

                            </div>

                            <div class="check-icon hidden text-indigo-600">
                                <i class="fas fa-check-circle text-lg"></i>
                            </div>

                        </div>

                        ${Number(method.id) === 3 ? `
                        <div class="mt-1 w-full">
                            <input type="text"
                                id="input-dp-${method.id}"
                                placeholder="Masukkan nominal..."
                                class="w-full px-3 py-2 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                onclick="event.stopPropagation()">
                        </div>
                        ` : ''}

                    </div>
                `;

                methodCard.addEventListener('click', function () {

                    container.querySelectorAll('.relative').forEach(c => {

                        c.classList.remove('border-indigo-500','bg-indigo-50');

                        const icon = c.querySelector('.check-icon');
                        if (icon) icon.classList.add('hidden');

                    });

                    this.classList.add('border-indigo-500','bg-indigo-50');

                    const icon = this.querySelector('.check-icon');
                    if (icon) icon.classList.remove('hidden');

                    hiddenInput.value = this.dataset.value;

                });

                container.appendChild(methodCard);

            });

        } else {

            container.innerHTML = `
                <div class="text-xs text-gray-400 italic">
                    Tidak ada metode pembayaran aktif.
                </div>
            `;

        }

    } catch (error) {

        console.error(error);

        container.innerHTML = `
            <div class="text-xs text-red-400">
                Gagal memuat metode pembayaran.
            </div>
        `;
    }
}

document.addEventListener('DOMContentLoaded', () => {

    const autoCost = [
        'bbm',
        'makan driver',
        'inap driver'
    ];

    document
        .querySelectorAll('.additional-cost-checkbox')
        .forEach(cb => {

            const id = cb.dataset.id;
            const name = cb.dataset.name;

            const detail =
                document.getElementById(
                    `cost-detail-${id}`
                );

            function toggleDetail() {

                if (
                    cb.checked &&
                    !autoCost.includes(name)
                ) {
                    detail.classList.remove('hidden');
                } else {
                    detail.classList.add('hidden');
                }
            }

            toggleDetail();

            cb.addEventListener(
                'change',
                toggleDetail
            );
        });
});

document.addEventListener("input", function (e) {

    if (
        e.target.matches('input[name^="cost_amount"]') ||
        e.target.matches('input[name="costPelayanan[]"]')
    ) {

        tanggalSampai.dispatchEvent(
            new Event("change")
        );
    }
});
